module.exports = __webpack_public_path__ + "media/images/fullscreen/root_homes_keyb_black_small-23b05d9a76036704574a932a412257d6.jpg";